import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import React, { useContext } from "react";
import ZeiterfassungSelectBauvorhaben from "../ZeiterfassungSelectBauvorhaben";
import ZeiterfassungSelectDatum from "../ZeiterfassungSelectDatum";
import ZeiterfassungSelectArbeitszeiten from "../ZeiterfassungSelectArbeitszeiten";
import ZeiterfassungSelectDatumErfassteZeiten from "../ZeiterfassungSelectDatumErfassteZeiten";
import ZeiterfassungContextProvider from "../../../../../Contexts/ZeiterfassungContext/ZeiterfassungContextProvider";
import ZeiterfassungContext from "../../../../../Contexts/ZeiterfassungContext/ZeiterfassungContext";
import ZeiterfassungNeuesBauvorhaben from "../ZeiterfassungNeuesBauvorhaben";
import ZeiterfassungNeueZeitmeldung from "../ZeiterfassungNeueZeitmeldung";

interface BauvorhabenAnlegenProps {
  onClose?: () => void;
}

export default function BauvorhabenAnlegen({ onClose }: BauvorhabenAnlegenProps) {
  return (
    // <ThemeProvider theme={theme.palette.main}>
    <>
      <ZeiterfassungContextProvider>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <ZeiterfassungNeuesBauvorhaben onClose={onClose} />
        </Box>
      </ZeiterfassungContextProvider>
    </>
    // </ThemeProvider>
  );
}
